import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import {
  faReact,
  faVuejs,
  faNodeJs,
  faCss3,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

export default function Technos() {
  return (
    <div>
      <div className="technos">
        <div className="badge p-5 mr-2">
          <img src="nextjs-icon.png" className="w-6 h-6 p-1" alt="NextJs" />{" "}
          NextJs / <FontAwesomeIcon icon={faReact} className="w-6 h-6 p-1" />{" "}
          React
        </div>
        <div className="badge p-5 mr-2">
          <img src="nuxt-logo.png" className="w-6 h-6 p-1" alt="NuxtJs" />{" "}
          NuxtJs / <FontAwesomeIcon icon={faVuejs} className="w-6 h-6 p-1" />
          VueJs
        </div>
        <div className="badge p-5 mr-2">
          <FontAwesomeIcon icon={faNodeJs} className="w-6 h-6 p-1" /> NodeJs
        </div>
      </div>
      <div className="technos">
        <div className="badge p-5 mr-2">
          <FontAwesomeIcon icon={faDatabase} className="w-6 h-6 p-1" /> MongoDB
        </div>
        <div className="badge p-5 mr-2">
          <FontAwesomeIcon icon={faCss3} className="w-6 h-6 p-1" /> TailwindCSS
        </div>
        <div className="badge p-5 mr-2">
          <FontAwesomeIcon icon={faGithub} className="w-6 h-6 p-1" /> Github
          Action
        </div>

        <p>
          Mes compagnons de développement (IA) : GitHub Copilot, ChatGPT, Gemini
        </p>
      </div>
    </div>
  );
}
